import axiosInstance from '../../lib/axios';
import { cancellableGet } from '../../lib/cancellableGet';

// Envelopes: lists { success, page, total, total_pages, data }; resources { success, data }.
const ROOT = '/admin/coach/customers';

export const fetchCaseload = (params = {}) => cancellableGet(`${ROOT}/`, { params });

export const fetchOverview = (customerId) => cancellableGet(`${ROOT}/${customerId}/overview/`);

export const fetchActivity = (customerId, date) =>
  cancellableGet(`${ROOT}/${customerId}/activity/`, {
    params: { date },
  });

export const fetchNight = (customerId, date) =>
  cancellableGet(`${ROOT}/${customerId}/nights/${date}/`);

export const fetchTrends = (customerId, params) =>
  cancellableGet(`${ROOT}/${customerId}/trends/`, { params });

export const fetchCoachProfile = (customerId) =>
  cancellableGet(`${ROOT}/${customerId}/coach-profile/`);

export const saveCoachProfile = async (customerId, body) => {
  const response = await axiosInstance.put(`${ROOT}/${customerId}/coach-profile/`, body);
  return response.data;
};

export const fetchNotes = (customerId, params = {}) =>
  cancellableGet(`${ROOT}/${customerId}/notes/`, { params });

// Writes carry an Idempotency-Key so a retried request cannot create a duplicate.
export const createNote = async (customerId, body) => {
  const response = await axiosInstance.post(
    `${ROOT}/${customerId}/notes/`,
    { body },
    { headers: { 'Idempotency-Key': crypto.randomUUID() } }
  );
  return response.data;
};

export const fetchInterventions = (customerId) =>
  cancellableGet(`${ROOT}/${customerId}/interventions/`);

export const decideIntervention = async (customerId, interventionId, outcome) => {
  const response = await axiosInstance.patch(
    `${ROOT}/${customerId}/interventions/${interventionId}/`,
    { outcome }
  );
  return response.data;
};

export const fetchSupportHistory = (customerId) =>
  cancellableGet(`${ROOT}/${customerId}/support-history/`);

// Both are consent-gated and audited on the backend, so they are read only when a coach asks.
export const fetchIntake = (customerId) =>
  cancellableGet(`${ROOT}/${customerId}/assessments/sleep_coach_intake/`);

export const fetchDailyCheckIns = (customerId, month) =>
  cancellableGet(`${ROOT}/${customerId}/daily-check-ins/`, { params: { month } });
